<div class="not-found tw-flex tw-h-screen tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-text-center">
  <p class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-primary))]">صفحه مورد نظر یافت نشد.</p>
  <img src="assets/images/404.png" alt="not found">
  <button smsir-button variant="secondary" size="sm" type="button" [routerLink]="'/'">
    بازگشت به خانه
  </button>
</div>
